@let r = row();

<div class="flex items-center gap-2 p-4 bg-base-200">
  <div class="flex flex-col flex-1 min-w-0 gap-2">
    @if (isInLocationModal()) {
      <div class="font-semibold">Active Commission</div>
    } @else {
      <div class="type-entity-name text-{{ rarityLabel() }}">
        {{ commissionName() }}
      </div>

      <div class="type-meta mb-2">For: {{ r.title }}</div>
    }

    @if (r.completed) {
      <span class="type-flavor">
        Daily commission fulfilled! Check back after the reset for another.
      </span>
    } @else {
      <div class="flex flex-wrap gap-2">
        @for (req of r.requirementEntries; track $index) {
          <app-slot-requirement
            [content]="req.content"
            [spritesheet]="req.spritesheet"
            [owned]="req.owned"
            [quantity]="req.quantity"
            [tooltip]="requirementTooltip(req)"
            [detailed]="true"
            (click)="navigateToTradeskill(req)"
          />
        }
      </div>

      <p class="my-2 type-flavor">{{ r.commission?.description }}</p>
    }
  </div>

  @if (!r.completed) {
    <div class="flex flex-col items-end gap-2 shrink-0">
      <div class="flex gap-2">
        @if (r.reputationReward) {
          <div class="badge badge-data">
            +{{ r.reputationReward | number }} Reputation
          </div>
        }

        @for (reward of r.rewards; track $index) {
          <div class="relative shrink-0">
            <div class="zoom-row">
              <app-slot-completion-reward
                [reward]="reward"
                [rewardText]="rewardQuantityLabel(reward)"
              />
            </div>
          </div>
        }
      </div>

      <div class="flex gap-2">
        @if (!isInLocationModal() && !r.isPartyHere) {
          @if (r.travelEtaSeconds !== undefined) {
            <button
              type="button"
              class="btn btn-xs btn-neutral tabular-nums"
              disabled
            >
              {{ etaLabel(r.travelEtaSeconds) }}
            </button>
          } @else {
            <button
              type="button"
              class="btn btn-xs btn-neutral"
              [disabled]="!r.canTravel"
              (click)="travel.emit()"
              appSfx="ui-click"
              [sfxOffset]="0"
              [sfxTrigger]="['click', 'hover']"
            >
              Travel Here
            </button>
          }
        }

        <button
          type="button"
          class="btn btn-xs btn-primary"
          [disabled]="!r.canFulfill || !r.isPartyHere"
          (click)="doTurnIn()"
          appSfx="ui-click"
          [sfxOffset]="1"
          [sfxTrigger]="['click', 'hover']"
        >
          Turn In Commission
        </button>
      </div>
    </div>
  }
</div>
